import { apiFetch } from './interceptor';
const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/v1';

export const loadRequestApi = {
    sendLoadRequest: async (token, params) => {
        const isFormData = params instanceof FormData;
        
        const headers = {
            'Authorization': `Bearer ${token}`
        };
        
        // Only set Content-Type for JSON, let browser set it for FormData
        if (!isFormData) {
            headers['Content-Type'] = 'application/json';
        }
        
        const response = await apiFetch(`${BASE_URL}/loadRequests`, {
            method: 'POST',
            headers,
            body: isFormData ? params : JSON.stringify(params)
        });
        const data = await response.json();
        return { status: response.status, data };
    },

    getLoadRequest: async (token, params) => {
        const response = await apiFetch(`${BASE_URL}/loadRequests?${new URLSearchParams(params).toString()}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        const data = await response.json();
        return { status: response.status, data };
    },
    
    updateLoadRequest: async (token, requestId, status, notes) => {
        const response = await apiFetch(`${BASE_URL}/loadRequests/${requestId}`, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                status,
                approvedNotes: notes
            })
        });
        const data = await response.json();
        return { status: response.status, data };
    },

    getLoadRequestCount: async (token) => {
        const response = await apiFetch(`${BASE_URL}/loadRequests/count/pending`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        const data = await response.json();
        return { status: response.status, data };
    }
    
};


